const fontMinHeightCss = { fontWeight: 500, minHeight: '24px' }

export default fontMinHeightCss
